export default "__VITE_PUBLIC_ASSET__1382b326__"